<template>
  <div class="invite-link-container">
    <div v-if="new Date(invitationData?.expirationTime) < new Date() || !invitationData" class="box">
      <img src="@/assets/img/warning.png" class="warning-img" alt="">
      <span class="warning-text">链接已失效</span>
    </div>
    <div v-if="new Date(invitationData?.expirationTime) > new Date()" class="box">
      <p class="box-title">
        <span>{{ invitationData.creatorName }}</span>
        <span>邀请您加入空间</span>
      </p>
      <div class="box-cover">
        <div class="space-avstar">
          <img
            v-if="invitationData.coverUrl"
            :src="$hosts.static(invitationData.coverUrl)"
            alt=""
          />
          <img
            v-else
            :src="require('@/assets/img/spaceBg.png')"
            alt=""
          />
        </div>
        <div class="space-text">
          <span
            :title="invitationData.spaceName"
            class="text-no-wrap"
            style="font-weight: bold; color: #495f70"
          >
            {{ invitationData.spaceName }}
          </span>
          <p class="space-name text-no-wrap">所有者：{{ invitationData.creatorName }}</p>
        </div>
      </div>

      <p class="box-time">链接到期时间：{{ $fmtTime(invitationData.expirationTime, 'YYYY年MM月DD日 HH:mm:ss') }}</p>
      <el-divider/>
      <el-button type="primary" @click="handleJoin">{{ invitationData.isMember? '您已加入过该空间，直接进入': '立即加入' }}</el-button>
    </div>
  </div>
</template>

<script>
import { joinTeamSpacesErrorCodeMap } from '../member/errorCodeMap'
export default {
  data() {
    return {
      spaceId: this.$route.params.spaceId,
      invitationKey: '',
      invitationData: {}
    }
  },
  created() {
    this.invitationKey = this.$route.params.linkCode
    this.getData()
  },
  methods: {
    async getData() {
      this.invitationData = await this.$api.member.getInvitationInfo(this.spaceId, this.invitationKey)
    },
    async handleJoin() {
      if (this.invitationData.spaceId) {
        this.$router.push({
          name: 'ComponentList',
          params: { spaceId: this.invitationData.spaceId },
        })
        return
      }
      try {
        const res = await this.$api.member.joinTeamSpaces(this.invitationKey)
        if (res && typeof res === 'number') {
          this.$tracks({
            event: 'joinSpace',
            params: { g_c_space_id: res.data || res }
          })
          this.$router.push({
            name: 'ComponentList',
            params: { spaceId: res },
          })
        }
      } catch (e) {
        this.$matchError(e.code, joinTeamSpacesErrorCodeMap, '加入失败')
        this.$router.push({ name: 'Index' })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.invite-link-container {
  height: 100vh;
  padding: 0 0;
  box-sizing: border-box;
  background-image: url("~@/assets/img/login-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  .box {
    width: 600px;
    height: 500px;
    background: @color-fill-white;
    box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .box-title {
      font-size: 14px;
      font-weight: normal;
      line-height: 32px;
      color: @text-tag-gery;
      margin-bottom: 12px;
    }
    .box-cover {
      width: 360px;
      height: 240px;
      border-radius: 2px;
      border: 1px solid #D2D9E3;
      display: flex;
      flex-direction: column;
      .space-avstar {
        width: 100%;
        height: 180px;
        border-bottom: 1px solid #d2d9e3;
        >img {
          width: 100%;
          height: 100%;
        }
      }
      .space-text {
        padding: 0 10px;
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .space-name {
          font-size: 12px;
          color: rgba(73, 95, 112, 0.6);;
        }
      }
    }
    .box-time {
      font-size: 12px;
      font-weight: normal;
      line-height: 32px;
      color: @text-tag-gery;
      margin: 16px 0 0;
    }
    .el-button {
      width: 360px;
      height: 40px;
    }
    .warning-img {
      width: 36px;
      height: 36px;
    }

    .warning-text {
      font-size: 16px;
      line-height: 32px;
      color: @text-tag-gery;
    }
  }
}
</style>
